import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import EmailDetail from './views/EmailDetail.vue'
import Wiki from './views/Wiki.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// @ts-ignore
import VueCookie from 'vue-cookie'
import WhoAmIApi from "@/repository/WhoAmIApi";
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(VueCookie )
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
        meta: { requiresAuth: true, showMenu: true}
    },
      {
          path: '/login',
          name: 'login',
          component: Login,
          meta: { requiresAuth: false}
      },
      {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: { requiresAuth: true}
      },
      {
          path: '/collaborate',
          name: 'collaborate',
          component: Wiki,
          meta: { requiresAuth: true}
      },
      {
          path: '/email/:id',
          name: 'email-detail',
          component: EmailDetail,
          meta: { requiresAuth: true}
      },
    {
      path: '/about',
      name: 'about',
        meta: { requiresAuth: true},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});
router.beforeEach(async (to, from, next) => {

    if(to.matched.some(record => record.meta.requiresAuth)) {
        if(sessionStorage.getItem('verifiedAuthStatus')==null || sessionStorage.getItem('verifiedAuthStatus')=='false'){
            let api = new WhoAmIApi()
            let resultOfCheck = await api.getWhoAmI()
            if (resultOfCheck){
                sessionStorage.setItem('verifiedAuthStatus', 'true')
                next()
            }
            else{
                next({
                    path: '/login',
                    params: { nextUrl: to.fullPath }
                });
            }
        }
        else{
            next()
        }

    } else {
        next()
    }
    if(to.matched.some(record => record.meta.showMenu)) {
        let api = new WhoAmIApi()
        let menuVisibleCheck = await api.getIsEmailMenuVisible()
        if (menuVisibleCheck){
            sessionStorage.setItem('menuVisible', 'true')
            next()
        }
        else{
            sessionStorage.setItem('menuVisible', 'false')
            next({
                path: '/collaborate',
                params: { nextUrl: to.fullPath }
            });
        }

    }

})
export default router;
